import { SnapRect } from "./snap.helpers"

/**
 * Where `element` is painted, relative to the canvas and in canvas units.
 *
 * @param canvasRect the canvas element's client rect — taken once by a caller that measures
 *        many elements against the same canvas
 * @param scale client px per canvas unit
 */
export const measureInCanvas = (element: Element, canvasRect: DOMRect, scale: number): SnapRect => {
    const rect = element.getBoundingClientRect()
    return {
        left: (rect.left - canvasRect.left) / scale,
        top: (rect.top - canvasRect.top) / scale,
        width: rect.width / scale,
        height: rect.height / scale,
    }
}
